import React from 'react';
import PropTypes from 'prop-types';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import RouterUtils from '../../../shared/routing/RouterUtils';
import { PsRoutes } from '../../../shared/routing/Routes';
import { ActiveBadge } from '../../../shared/components/ActiveLabel';
import { PsListTable } from '../../../shared/components/list-table/PsListTable';
import DocumentState from '../../../shared/components/DocumentState';
import { PsMoreMenu } from '../../../shared/components/more-menu/PsMoreMenu';

export class MachineListTable extends React.Component {

    render() {
        const {
            data,
            error,
            loading,
        } = this.props;

        return (
            <PsListTable
                data={data}
                error={error}
                loading={loading}
                headings={(
                    <tr>
                        <th>{I18nUtils.tr('TR_ESTADO')}</th>
                        <th>{I18nUtils.tr('TR_DOCUMENTACION')}</th>
                        <th>{I18nUtils.tr('TR_SUBCONTRATA')}</th>
                        <th>{I18nUtils.tr('TR_MATRICULA')}</th>
                        <th>{I18nUtils.tr('TR_MARCA')}</th>
                        <th>{I18nUtils.tr('TR_MODELO')}</th>
                        <th>{I18nUtils.tr('TR_ESQUEMA')}</th>
                        <th/>
                    </tr>
                )}
            >
                {
                    data.map((machine) => {
                        const machineId = machine.id();
                        const outsourceId = machine.companyId()
                        const options = [
                            {
                                label: I18nUtils.tr('TR_EDITAR'),
                                route: RouterUtils.generateRoute(
                                    PsRoutes.MY_OUTSOURCES_MACHINES_DETAIL,
                                    { outsourceId, machineId },
                                ),
                            },
                        ];

                        return (
                            <tr key={machineId}>
                                <td><ActiveBadge active={machine.isActive()}/></td>
                                <td><DocumentState state={machine.documentationStateData()}/></td>
                                <td>{machine.companyDescription()}</td>
                                <td>{machine.licensePlate()}</td>
                                <td>{machine.brand()}</td>
                                <td>{machine.model()}</td>
                                <td>{machine.documentationDescription()}</td>
                                <td><PsMoreMenu options={options}/></td>
                            </tr>
                        );
                    })
                }
            </PsListTable>
        );
    }
}

MachineListTable.propTypes = {
    data: PropTypes.array,
    error: PropTypes.string,
    loading: PropTypes.bool,
};

MachineListTable.defaultProps = {
    data: [],
    error: '',
};



// WEBPACK FOOTER //
// ./src/app/my-outsources/machine/list/MachineListTable.jsx